import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	// 全局共享数据
	state: {
		shenLv: '',
		hasGen:false
	},

	// 修改state唯一入口
	mutations: {
		shenLvData(state, val) {
			state.shenLv = val;
		},
		setGen(state, val){
			state.hasGen = val;
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js